import classNames from 'classnames';

import { createSerieRow } from '../../lib/blocks';

import HomePageBlocks, { HomePageBlocksProps } from './HomePageBlocks';

import styles from '../../styles/pages/home-page-mollo.module.css';

function HomePageMollo({ brand, className = null, ...props }: HomePageBlocksProps) {
    const additionalBlocks = [
        createSerieRow(
            'pretes-pas-pretes',
            {
                className: styles.section,
                uniqueDocuments: false,
                cardType: 'horizontal',
                cardTheme: 'box-translucent',
                autoColumns: true,
                cardWidth: 300,
                cardRatio: 'square',
                count: 10,
                listTitle: 'Derniers épisodes',
                // withDescription: true,
            },
            {
                order: 'old',
            },
        ),
    ];
    return (
        <HomePageBlocks
            {...props}
            additionalBlocks={additionalBlocks}
            brand={brand}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

export default HomePageMollo;
